module.exports = __webpack_public_path__ + "static/media/pdp_paperNatural.aa981626.jpg";